import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Icon, IconClose, IconButton } from '@redlink/components/atoms';

export const LinkTemporaryAddedItem = memo(
  ({ item: { logoName, title, url }, onRemove }) => {
    const { styles, colors } = useStyle();

    return (
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          <Icon name={logoName} size={24} color={colors.gray23} />
        </View>
        <View style={styles.textsContainer}>
          <Text style={styles.titleText}>{title}</Text>
          <Text style={styles.subtitleText}>{url}</Text>
        </View>
        <IconButton onPress={() => onRemove(url)} style={styles.iconButton}>
          <IconClose size={18} color={colors.white} />
        </IconButton>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    flex: 1,
    height: 64,
    padding: 8,
    borderWidth: 1,
    borderRadius: 10,
    alignItems: 'center',
    borderColor: colors.gray22,
    flexDirection: 'row-reverse',
  },
  iconContainer: {
    width: 32,
    marginStart: 20,
    alignItems: 'center',
  },
  textsContainer: {
    flex: 1,
  },
  titleText: {
    fontSize: 16,
    lineHeight: 24,
    color: colors.gray23,
    fontWeight: 'bold',
  },
  subtitleText: {
    fontSize: 12,
    lineHeight: 17,
    color: colors.gray23,
    fontWeight: '300',
  },
  iconButton: {
    width: 20,
    height: 20,
    padding: 0,
    marginStart: 8,
    backgroundColor: colors.gray21,
  },
}));
